import { environment } from "../../environments/environment";

export const SERVICE_URL = {
  CRYPTO_JWKS: "api/crypto/jwks",
  KEYCLOCK_SERVICE: "api/keycloak/v2/graph/",
  KEYCLOAK_REALMS: "api/keycloak/v1/realms/",
  PROFILE: environment.preprod
    ? "api/profiles-preprod/v3/lokos-profile-preprod/"
    : "api/profiles/v3/lokos-profile/",
  CADRE_PROFILE: "api/cadre-profile/v1/cadre-profile/",
  REPORTS: "api/reports/v3/reporting/",
};
